import React from 'react';
import {
  FaMobileAlt,
  FaLaptopCode,
  FaServer,
  FaCloud,
  FaLayerGroup,
  FaBrain,
  FaBolt,
  FaBuilding
} from 'react-icons/fa';
import Section from './layout/Section';
import ScrollReveal from './animations/ScrollReveal';
import SpotlightCard from './effects/SpotlightCard';

const services = [
  {
    title: 'Mobile Apps',
    icon: FaMobileAlt,
    body: 'One codebase, both stores, no compromise on feel. From first screen to a live release.'
  },
  {
    title: 'Web Applications',
    icon: FaLaptopCode,
    body: 'Fast, responsive products that stay quick as features pile up, not just on launch day.'
  },
  {
    title: 'Backend Development',
    icon: FaServer,
    body: 'APIs and services built to be dependable. The kind of backend you stop thinking about once it ships.'
  },
  {
    title: 'SaaS Platforms',
    icon: FaLayerGroup,
    body: 'Multi tenant products with billing, roles, and onboarding handled properly from day one.'
  },
  {
    title: 'AI Integrations',
    icon: FaBrain,
    body: 'AI wired into features people actually use, with real fallbacks when the model gets it wrong.'
  },
  {
    title: 'Cloud Solutions',
    icon: FaCloud,
    body: 'Infrastructure sized to your product today, with room to grow. No bill surprises.'
  },
  {
    title: 'Automation',
    icon: FaBolt,
    body: 'Repetitive work your team still does by hand, turned into something that runs quietly in the background.'
  },
  {
    title: 'Enterprise Applications',
    icon: FaBuilding,
    body: 'Internal tools that fit how your teams already work, with access control taken seriously.'
  }
];

export default function Services() {
  return (
    <Section
      id="services"
      eyebrow="Services"
      title="How I can help"
      lead="Whatever the label, the job is usually the same. Understand the problem properly, then build something dependable around it."
      className="border-y border-slate-200/80 bg-white dark:border-white/[0.06] dark:bg-slate-950/40"
    >
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {services.map((service, index) => {
          const Icon = service.icon;
          return (
            <ScrollReveal key={service.title} direction="up" delay={(index % 4) * 0.06}>
              <SpotlightCard className="h-full p-6">
                <span
                  className="mb-5 flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-br
                             from-blue-500/15 to-indigo-500/5 text-blue-500 ring-1 ring-inset ring-blue-500/15
                             transition-transform duration-500 ease-smooth group-hover:scale-110"
                >
                  <Icon className="h-[18px] w-[18px]" aria-hidden="true" />
                </span>
                <h3 className="text-[15px] font-semibold text-slate-900 dark:text-white">{service.title}</h3>
                <p className="mt-2.5 text-sm leading-relaxed text-slate-600 dark:text-slate-400">
                  {service.body}
                </p>
              </SpotlightCard>
            </ScrollReveal>
          );
        })}
      </div>

      <ScrollReveal direction="up" delay={0.1}>
        <p className="mt-12 text-center text-sm text-slate-500 dark:text-slate-400">
          Not sure which of these you need?{' '}
          <a
            href="#contact"
            className="font-semibold text-blue-600 underline-offset-4 hover:underline dark:text-blue-400"
          >
            Tell me the problem
          </a>{' '}
          and I&rsquo;ll tell you honestly if I&rsquo;m the right fit.
        </p>
      </ScrollReveal>
    </Section>
  );
}
